export default "__VITE_ASSET__DSlrfRP1__"